import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';

import styles from './EditCardDetailsForm.module.scss';

type Props = {
  renderPaymentMethod?: () => JSX.Element | null;
  submitting: boolean;
  onCancel: () => void;
};

const EditCardDetailsForm: React.FC<Props> = ({ renderPaymentMethod, submitting }) => {
  const { t } = useTranslation(['common', 'user']);
  return (
    <div>
      <div>{renderPaymentMethod ? renderPaymentMethod() : null}</div>
      {submitting && <LoadingOverlay transparentBackground inline />}
    </div>
  );
};

export default EditCardDetailsForm;
